/* =========================================================
   rm-icons.js - Font Awesome icons across the whole theme
   Every <span class="ms">icon_name</span> in the theme (and the
   icon names typed in Customize) is turned into a Font Awesome icon.
   You can also type a Font Awesome name directly in Customize,
   e.g. "fa-solid fa-book-open" or just "fa-book-open".
   ========================================================= */
(function(){
  var MAP = {
    /* header / navigation */
    'menu':'fa-solid fa-bars','close':'fa-solid fa-xmark','search':'fa-solid fa-magnifying-glass',
    'favorite':'fa-regular fa-heart','favorite_border':'fa-regular fa-heart','account_circle':'fa-regular fa-circle-user',
    'person':'fa-solid fa-user','shopping_bag':'fa-solid fa-bag-shopping','shopping_cart':'fa-solid fa-cart-shopping',
    'add_shopping_cart':'fa-solid fa-cart-plus','expand_more':'fa-solid fa-chevron-down','expand_less':'fa-solid fa-chevron-up',
    'chevron_left':'fa-solid fa-chevron-left','chevron_right':'fa-solid fa-chevron-right',
    'arrow_back':'fa-solid fa-arrow-left','arrow_forward':'fa-solid fa-arrow-right','home':'fa-solid fa-house',
    /* commerce */
    'local_shipping':'fa-solid fa-truck-fast','payments':'fa-solid fa-money-bill-wave','credit_card':'fa-regular fa-credit-card',
    'verified':'fa-solid fa-certificate','new_releases':'fa-solid fa-certificate','inventory_2':'fa-solid fa-box-open',
    'loyalty':'fa-solid fa-tags','sell':'fa-solid fa-tag','local_offer':'fa-solid fa-tag','percent':'fa-solid fa-percent',
    'redeem':'fa-solid fa-gift','card_giftcard':'fa-solid fa-gift','storefront':'fa-solid fa-store','lock':'fa-solid fa-lock',
    'tune':'fa-solid fa-sliders','filter_list':'fa-solid fa-filter','sort':'fa-solid fa-arrow-down-wide-short',
    'delete':'fa-regular fa-trash-can','add':'fa-solid fa-plus','remove':'fa-solid fa-minus',
    'check':'fa-solid fa-check','done':'fa-solid fa-check','check_circle':'fa-solid fa-circle-check',
    'error':'fa-solid fa-circle-exclamation','info':'fa-solid fa-circle-info','share':'fa-solid fa-share-nodes',
    'autorenew':'fa-solid fa-rotate','assignment_return':'fa-solid fa-rotate-left','security':'fa-solid fa-shield-halved',
    'gpp_good':'fa-solid fa-shield-halved',
    /* books & categories */
    'auto_stories':'fa-solid fa-book-open','menu_book':'fa-solid fa-book','book':'fa-solid fa-book',
    'local_library':'fa-solid fa-book-open-reader','library_books':'fa-solid fa-book','collections_bookmark':'fa-solid fa-layer-group',
    'bookmark':'fa-solid fa-bookmark','stars':'fa-solid fa-star','star':'fa-solid fa-star','child_care':'fa-solid fa-child-reaching',
    'toys':'fa-solid fa-puzzle-piece','military_tech':'fa-solid fa-medal','emoji_events':'fa-solid fa-trophy',
    'whatshot':'fa-solid fa-fire','local_fire_department':'fa-solid fa-fire','bolt':'fa-solid fa-bolt','category':'fa-solid fa-shapes',
    'history_edu':'fa-solid fa-feather','edit':'fa-solid fa-pen','draw':'fa-solid fa-pen-nib','palette':'fa-solid fa-palette',
    'psychology':'fa-solid fa-brain','science':'fa-solid fa-flask','rocket_launch':'fa-solid fa-rocket','pets':'fa-solid fa-paw',
    'mosque':'fa-solid fa-mosque','theater_comedy':'fa-solid fa-masks-theater','mood':'fa-regular fa-face-smile',
    'face':'fa-regular fa-face-smile','sentiment_very_satisfied':'fa-regular fa-face-laugh','groups':'fa-solid fa-users',
    'public':'fa-solid fa-earth-africa','travel_explore':'fa-solid fa-earth-africa','fingerprint':'fa-solid fa-fingerprint',
    'skull':'fa-solid fa-skull','diamond':'fa-regular fa-gem','headphones':'fa-solid fa-headphones',
    /* heroes */
    'shield':'fa-solid fa-shield-halved','visibility':'fa-solid fa-eye','medical_services':'fa-solid fa-kit-medical',
    /* contact */
    'call':'fa-solid fa-phone','phone':'fa-solid fa-phone','phone_in_talk':'fa-solid fa-phone-volume',
    'mail':'fa-regular fa-envelope','email':'fa-regular fa-envelope','mark_email_read':'fa-solid fa-envelope-circle-check',
    'send':'fa-solid fa-paper-plane','location_on':'fa-solid fa-location-dot','schedule':'fa-regular fa-clock',
    'support_agent':'fa-solid fa-headset','chat':'fa-brands fa-whatsapp','photo_camera':'fa-brands fa-instagram',
    'smart_display':'fa-brands fa-youtube',
    /* empty states */
    'explore_off':'fa-regular fa-compass','search_off':'fa-solid fa-magnifying-glass-minus'
  };
  var STYLE = /(^|\s)fa-(solid|regular|brands|light|thin|duotone|sharp)(\s|$)/;
  function toClass(name){
    name = (name || '').trim();
    if (!name) return null;
    if (name.indexOf('fa-') === 0 || name.indexOf(' fa-') > -1) return STYLE.test(name) ? name : 'fa-solid ' + name;
    return MAP[name] || MAP[name.toLowerCase()] || 'fa-solid fa-book-open';
  }
  function convert(el){
    var name = el.textContent.trim();
    if (!name) return;
    var i = document.createElement('i');
    i.className = toClass(name);
    i.setAttribute('aria-hidden', 'true');
    el.textContent = '';
    el.appendChild(i);
    el.setAttribute('data-icon', name);
    el.classList.add('is-fa');
  }
  function scan(root){
    if (!root || root.nodeType !== 1) return;
    if (root.classList.contains('ms')) { convert(root); return; }
    var list = root.querySelectorAll('.ms');
    for (var k = 0; k < list.length; k++) convert(list[k]);
  }
  scan(document.documentElement);
  if (window.MutationObserver) {
    new MutationObserver(function(muts){
      muts.forEach(function(m){
        var t = m.type === 'characterData' ? m.target.parentElement : m.target;
        var ms = t && t.closest ? t.closest('.ms') : null;
        if (ms) { convert(ms); return; }
        if (m.addedNodes) for (var k = 0; k < m.addedNodes.length; k++) scan(m.addedNodes[k]);
      });
    }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  }
  document.addEventListener('DOMContentLoaded', function(){ scan(document.documentElement); });
})();
